import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AdminAuthService } from '@sgm-frontend/core';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { NavbarComponent } from './components/navbar/navbar.component';

@Component({
  imports: [RouterModule, CommonModule, NavbarComponent, SidebarComponent, ToastModule, NavbarComponent, ConfirmDialogModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  constructor(public authService: AdminAuthService ) {

     const token = this.generateDeviceToken();
     if(!localStorage.getItem('deviceToken')){
      localStorage.setItem('deviceToken',token);
     }
  }
    generateDeviceToken(length: number = 20): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let token2 = '';
  for (let i = 0; i < length; i++) {
    token2 += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return token2;
}
}
